import { createSelector } from '@ngrx/store';

import { Country } from '@recruitee/http/types';
import { createSingleEntityStore } from '@recruitee/ngrx';

import { CountryCodeMap } from '../location.types';

const { actions, namespace, selectors, reducer } = createSingleEntityStore<Country[] | null>()(
  'Country',
);

const CountrySelectors = {
  ...selectors,
  selectCountryCodeMap: createSelector(selectors.data, data => {
    if (!data) return null;

    return data.reduce((acc, country) => {
      acc[country.code] = country;
      return acc;
    }, <CountryCodeMap>{});
  }),
};

export {
  actions as CountryActions,
  namespace as CountryNamespace,
  reducer as CountryReducer,
  CountrySelectors,
};
